import script from "./ordinations.vue?vue&type=script&setup=true&lang=js"
export * from "./ordinations.vue?vue&type=script&setup=true&lang=js"

import "./ordinations.vue?vue&type=style&index=0&id=52b1fe26&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b1fe26"]])

export default __exports__